export const PROCTORING_TYPE = {
  LIVE: "live",
  LITE: "lite",
};

export const APP_NOVA = "NjQ0OWRhMTQ2YTE4MmMyNTVlNTI4";
